export default __webpack_public_path__ + "static/media/markAttendanceWhite.ace56afb.svg";